import merge from "lodash/merge";
import { BarData, BarSeriesOptions } from "../chart.typings";
import BaseChartSeries from "./baseSeries";
import { barSeriesOptions } from "../../../assets/constants";

class BarSeries extends BaseChartSeries<BarData, BarSeriesOptions> {

    addSeriesToChart() {
        return this.chart.chartApi.addBarSeries(this.seriesOptions)
    }

    getDefaultOptions(): BarSeriesOptions {
        return merge(barSeriesOptions, this.options)
    }

}

export default BarSeries;